module.exports = __webpack_public_path__ + "static/media/logo.2d0b5e4d.png";